/* const URL = process.env.REACT_APP_APIURL; */
const URL = "https://tlsapi.invgap.org";
export default URL;
